module.exports = __webpack_public_path__ + "static/media/linkedin.3c8afea5.svg";